import React, { useState } from "react";
import Page from "components/base/Page";
import { FileSelector } from "components/base/Form";
import { POList } from "./InvoiceVerifyComponents";
import { useLTDInvoiceFileUpload, useABInvoiceFileUpload } from "./hooks";

const InvoiceVerify = () => {
  const [systemType, setSystemType] = useState("LTD");

  const ltdHook = useLTDInvoiceFileUpload();
  const abHook = useABInvoiceFileUpload();
  const { extractedData } = systemType === "LTD" ? ltdHook : abHook;

  const handleLTDUpload = (e) => {
    setSystemType("LTD");
    ltdHook.handleFileUpload(e);
  };

  const handleABUpload = (e) => {
    setSystemType("AB");
    abHook.handleFileUpload(e);
  };

  return (
    <Page
      title="Invoice PO Verification"
      leftButtons={
        <div className="flex space-x-3">
          <FileSelector
            title={abHook.loading ? "Processing..." : "Upload AB Invoice"}
            onChange={handleABUpload}
            accept=".xlsx,.xls"
            disabled={ltdHook.loading || abHook.loading}
            uploading={abHook.loading}
            className="btn btn-secondary"
          />
          <FileSelector
            title={ltdHook.loading ? "Processing..." : "Upload LTD Invoice"}
            onChange={handleLTDUpload}
            accept=".xlsx,.xls"
            disabled={ltdHook.loading || abHook.loading}
            uploading={ltdHook.loading}
            className="btn btn-primary"
          />
        </div>
      }
    >
      <div className="p-6">
        {extractedData?.items?.length > 0 ? (
          <POList
            extractedData={extractedData.items}
            systemType={systemType}
          />
        ) : (
          <div className="card">
            <p className="mb-2">
              Upload invoice Excel file to verify against purchase orders on
              Odoo.
            </p>
            <p className="text-xs text-gray-500">
              Supported formats: .xlsx, .xls
            </p>
          </div>
        )}
      </div>
    </Page>
  );
};

export default InvoiceVerify;
